'use client';
// -------------- 组件 -------------------- //
import SafeLink from '@/components/SafeLink';
// --------------  图标 -------------------- //
import ArrowRight from '@/assets/icons/ArrowRight.svg';
// -------------- scss -------------------- //
import CDNImage from '@/components/cdnImage/cdnImage';
import styles from './style.module.scss';
// -------------- Constants -------------------- //
const BEST_SELLER_HREF = '/promo/best-seller';
// ---------------引入埋点------------------
import { useTranslation } from '@/i18n/client';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';
// ---------------- 监控 ---------------- //
import {
  HOME_EVENT_NAMES,
  homeBusinessLogger,
  HOME_TRACK_TYPE,
} from '@/utils/logger/instance/homeBusinessLogger';
import { useRouter } from 'next/navigation';

export default function Module({
  moduleData,
  floorIndex,
}: {
  moduleData: any;
  floorIndex: number;
}) {
  const { externalData, dataBatch } = moduleData;
  const { t } = useTranslation();
  const router = useRouter();
  const handleClick = (e: any) => {
    spmTrackingUtils.spmClick({
      spm: 'a0145.b002218.c00002480.more',
      page_id: 'Home_Main',
      event_id: 'Home_Pro_BestSellers_More',
      target: e.target as HTMLElement,
    });
  };
  const title = dataBatch?.config[0].title || t('bestSeller.title');
  if (externalData?.data && externalData?.data.length === 0) {
    homeBusinessLogger({
      eventName: HOME_EVENT_NAMES.BEST_SELLER_NO_DATA,
      category: {
        type: HOME_TRACK_TYPE.CMS_JS_ERROR,
      },
      message: {
        msg: 'Best seller 无数据',
      },
    });
    return null;
  }
  return (
    <div className={styles['uk-h5-best-seller']}>
      <div className={styles.header}>
        <SafeLink href={BEST_SELLER_HREF}>
          <div className={styles.headerContainer}>
            <div className={styles.headerTitle}>{title}</div>
            <div className={styles.buttonContainer}>
              <div className={styles.headerButton}>
                <p>{dataBatch?.config[0].jumpButtonName || t('bestSeller.viewMore')}</p>
              </div>
            </div>
          </div>
          <div
            className={styles.rightIcon}
            onClick={(e) => handleClick(e)}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
            data-exp={JSON.stringify({
              spm: 'a0145.b002218.c00002480.more',
              page_id: 'Home_Main',
              event_id: 'Home_Pro_BestSellers_More_Expo',
            })}
          >
            <ArrowRight className={styles.headerIcon} />
          </div>
        </SafeLink>
      </div>
      <div className={styles.cardContainer}>
        {externalData &&
          externalData.data.map((item: any, index: any) => {
            return (
              <button
                className={styles.card}
                key={item.categoryTabName}
                onClick={(e) => {
                  router.push(`/promo/best-seller?tab=${item.uuid}`);
                  spmTrackingUtils.spmClick({
                    spm: `a0145.b002218.c00002480.${index + 1}`,
                    page_id: 'Home_Main',
                    event_id: 'Home_Pro_BestSellers',
                    json_param: JSON.stringify({
                      rankId: item?.sequenceId,
                      rankName: item?.categoryTabName,
                      scoreNum: item?.viewedStr,
                      type: item?.type,
                      cateLevel: item?.level,
                      skuId: externalData.data.map((item: any) => item?.skuId.toString()),
                    }),
                    target: e.target as HTMLElement,
                  });
                  // goToCurrentRankPage(item.sequenceId, item.categoryTabName);
                }}
                data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                data-exp={JSON.stringify({
                  spm: `a0145.b002218.c00002480.${index + 1}`,
                  page_id: 'Home_Main',
                  event_id: 'Home_Pro_BestSellers_Expo',
                  json_params: {
                    rankId: item?.sequenceId,
                    rankName: item?.categoryTabName,
                    scoreNum: item?.viewedStr,
                    type: item?.type,
                    cateLevel: item?.level,
                    skuId: externalData.data.map((item: any) => item?.skuId.toString()),
                  },
                })}
              >
                <div className={styles.imgContainer}>
                  <CDNImage
                    // @ts-ignore
                    src={item?.imageUrl}
                    width={120}
                    height={120}
                    alt={item.categoryTabName}
                    style={{ maxHeight: '120px', objectFit: 'contain' }}
                    priority={floorIndex < 6 && index < 4}
                  />
                  <div className={styles.UK_mask}></div>
                </div>

                <div className={styles.cardTitle}>{item.categoryTabName}</div>
                <div className={styles.subTitleBox}>
                  <span className={styles.subTitleText}>{item.viewedStr}</span>
                </div>
              </button>
            );
          })}
      </div>
    </div>
  );
}
